// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__FJTYk","eventId":"Table_eventId__2qxGP"};